export const b2Words = [
  {
    word: "accurate",
    image: "https://media0.giphy.com/media/v1.Y2lkPTc5MGI3NjExeXB6MDBucDk1ejF2dHNtb290dW9tdno1NTVxbHd3aGF3M3I0dGgxaCZlcD12MV9pbnRlcm5hbF9naWZfYnlfaWQmY3Q9Zw/PkPWNoQ6Br3Aa9Oa3g/giphy.gif",
    synonyms: ["precise", "correct", "exact"],
    example: "The report was accurate and detailed.",
    definition: "Free from mistakes or errors; correct in all details."
  },
  {
    word: "acknowledge",
    image: "https://media1.giphy.com/media/v1.Y2lkPTc5MGI3NjExZmJsemFvcG41aGFkdGs1djVlYXp2cWsxbGZqdmc1bTN4ZHNtYTFuMiZlcD12MV9pbnRlcm5hbF9naWZfYnlfaWQmY3Q9Zw/VEKTJLrj6J4p1nMybe/giphy.gif",
    synonyms: ["recognize", "admit", "accept"],
    example: "He acknowledged that he had made a mistake.",
    definition: "To accept or admit the existence or truth of something."
  },
  {
    word: "approach",
    image: "https://plus.unsplash.com/premium_photo-1723874571151-052a8894a37d?q=80&w=1109&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
    synonyms: ["method", "strategy", "technique"],
    example: "We need a new approach to solve this problem.",
    definition: "A way of dealing with a situation or problem."
  },
  {
    word: "assume",
    image: "https://i.pinimg.com/736x/e7/3b/e4/e73be4491b1c445720b9370e9a62c42a.jpg",
    synonyms: ["suppose", "presume", "guess"],
    example: "I assumed he was coming to the party.",
    definition: "To think something is true without proof."
  },
  {
    word: "aware",
    image: "https://media2.giphy.com/media/v1.Y2lkPTc5MGI3NjExY3hlcHJjdXMwaHlrZWNocmI1eHpxMWxwYzR5cTFjZTk4c2hoYzJlYiZlcD12MV9pbnRlcm5hbF9naWZfYnlfaWQmY3Q9Zw/26gsvA7sDa86fDu6s/giphy.gif",
    synonyms: ["conscious", "informed", "mindful"],
    example: "She wasn't aware of the risks involved.",
    definition: "Knowing or realizing something."
  },
  {
    word: "collapse",
    image: "https://media1.giphy.com/media/v1.Y2lkPTc5MGI3NjExeDIwa3IwM3IwcDE3eGd6b2QzY29wNGllaTlmMGRlb3FxaTJmenk3dyZlcD12MV9pbnRlcm5hbF9naWZfYnlfaWQmY3Q9Zw/4VXVA0H5geRSQdw1Pe/giphy.gif",
    synonyms: ["fall down", "crumble", "break down"],
    example: "The building collapsed during the earthquake.",
    definition: "To fall down suddenly due to damage or weakness."
  },
  {
    word: "concern",
    image: "https://media1.giphy.com/media/v1.Y2lkPTc5MGI3NjExaDdia3o0cXE4MTJ1dTc5dGs5dDhiZms0ZXk1bzVyNDhxdHdqZmQ1aSZlcD12MV9pbnRlcm5hbF9naWZfYnlfaWQmY3Q9Zw/5lsbmtM9pZL8j3TJ8A/giphy.gif",
    synonyms: ["worry", "anxiety", "unease"],
    example: "There is growing concern about climate change.",
    definition: "A feeling of worry about something important."
  },
  {
    word: "confirm",
    image: "https://media4.giphy.com/media/v1.Y2lkPTc5MGI3NjExeXpwM2JnZ3dscjN3ZnNwYWVsOXRnY29nZXZkbmQycnhraDk3ZHVnbCZlcD12MV9pbnRlcm5hbF9naWZfYnlfaWQmY3Q9Zw/DOvmLg9pw9hUsc8mWp/giphy.gif",
    synonyms: ["verify", "validate", "prove"],
    example: "The doctor confirmed the diagnosis.",
    definition: "To show or prove something is true or correct."
  },
  {
    word: "convince",
    image: "https://media4.giphy.com/media/v1.Y2lkPTc5MGI3NjExeDJ4Zjg2Z2ZqOWMxdHN1dnFjODBlbng4NGs3N2wyenZlYjZ0N24zbCZlcD12MV9pbnRlcm5hbF9naWZfYnlfaWQmY3Q9Zw/fH3LbssRHBIxSu6vf7/giphy.gif",
    synonyms: ["persuade", "influence", "sway"],
    example: "She convinced me to join the project.",
    definition: "To make someone believe something is true or right."
  },
  {
    word: "debate",
    image: "https://i.pinimg.com/736x/b2/72/0e/b2720e99eaaaa5b9c3571432c495b096.jpg",
    synonyms: ["discussion", "argument", "dispute"],
    example: "They had a long debate about the policy.",
    definition: "A formal discussion on a particular topic."
  },
  {
    word: "demand",
    image: "https://media4.giphy.com/media/v1.Y2lkPTc5MGI3NjExNHp4bG9pOXU2amxhOXFvNDc5MW15Z2M3ZTAwaThoMHp0N2RxMHhzNCZlcD12MV9pbnRlcm5hbF9naWZfYnlfaWQmY3Q9Zw/EPjhXq9QbLvCJKZk5z/giphy.gif",
    synonyms: ["require", "ask for", "request"],
    example: "Workers are demanding better pay.",
    definition: "To ask for something forcefully."
  },
  {
    word: "determine",
    image: "https://i.pinimg.com/736x/df/bf/cc/dfbfcc990f634a71c61fee9f8e7709f9.jpg",
    synonyms: ["decide", "establish", "define"],
    example: "The test will determine your level.",
    definition: "To decide or establish something after thinking carefully."
  },
  {
    word: "effective",
    image: "https://i.pinimg.com/736x/92/40/ef/9240ef093578c01b6f4e087ef9989b5a.jpg",
    synonyms: ["efficient", "productive", "successful"],
    example: "This method is very effective.",
    definition: "Producing the desired result."
  },
  {
    word: "emphasize",
    image: "https://media2.giphy.com/media/v1.Y2lkPTc5MGI3NjExNmx4bnI5MHN2Y3ZmaHB1b2pzb2ZsbndlMjlmeGlmb2xrMXRnaTlwNyZlcD12MV9pbnRlcm5hbF9naWZfYnlfaWQmY3Q9Zw/3o6nUNAvJxhXJAtC5W/giphy.gif",
    synonyms: ["highlight", "stress", "underline"],
    example: "The teacher emphasized the importance of homework.",
    definition: "To give special importance to something."
  },
  {
    word: "establish",
    image: "https://i.pinimg.com/736x/ed/86/b1/ed86b13f03535a78e2ab94278ad4f184.jpg",
    synonyms: ["set up", "found", "create"],
    example: "The company was established in 1990.",
    definition: "To start or create something (like a company or rule)."
  },
  {
    word: "evidence",
    image: "https://i.pinimg.com/736x/43/0c/c4/430cc473b8d806b2b998733fa5165952.jpg",
    synonyms: ["proof", "indication", "confirmation"],
    example: "There is no evidence that he committed the crime.",
    definition: "Information that shows something is true or valid."
  },
  {
    word: "frequent",
    image: "https://media1.giphy.com/media/v1.Y2lkPTc5MGI3NjExdnJ6dDFndjI1bmNuZm5idHZuZ2w5ZHE4aGp4MXJ5c2diZ3Nrb242cyZlcD12MV9pbnRlcm5hbF9naWZfYnlfaWQmY3Q9Zw/DJAWMtwj9YWBt6g3U2/giphy.gif",
    synonyms: ["regular", "repeated", "common"],
    example: "He is a frequent visitor to the library.",
    definition: "Happening often or regularly."
  },
  {
    word: "generate",
    image: "https://i.pinimg.com/736x/19/52/16/195216ae119a2dfc47630c748976cf1c.jpg",
    synonyms: ["create", "produce", "make"],
    example: "The project generated a lot of interest.",
    definition: "To produce or cause something."
  },
  {
    word: "impact",
    image: "https://images.unsplash.com/photo-1519455953755-af066f52f1a6?q=80&w=687&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
    synonyms: ["effect", "influence", "result"],
    example: "The new law had a big impact on businesses.",
    definition: "The effect or influence of one thing on another."
  },
  {
    word: "influence",
    image: "https://i.pinimg.com/736x/c0/8f/89/c08f89cee1f5072db13cbaa71895126d.jpg",
    synonyms: ["affect", "sway", "shape"],
    example: "His ideas have influenced many people.",
    definition: "The power to have an effect on people or things."
  },
  {
    word: "maintain",
    image: "https://images.unsplash.com/photo-1625047509168-a7026f36de04?q=80&w=880&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
    synonyms: ["keep", "preserve", "sustain"],
    example: "She maintains her car very well.",
    definition: "To keep something in good condition or at the same level."
  },
  {
    word: "obtain",
    image: "https://media4.giphy.com/media/v1.Y2lkPTc5MGI3NjExbTBwZ2hveDJ0OGo3MTN2MmJwaHB0bGNkMjlpeXdtaWZzc240ODNsbCZlcD12MV9pbnRlcm5hbF9naWZfYnlfaWQmY3Q9Zw/kHD4UWThlxIvmczcJa/giphy.gif",
    synonyms: ["get", "acquire", "receive"],
    example: "You need a license to obtain this software.",
    definition: "To get something, especially by effort."
  },
  {
    word: "participate",
    image: "https://plus.unsplash.com/premium_photo-1664304095595-e428558e8161?q=80&w=1170&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
    synonyms: ["take part", "join", "engage"],
    example: "Many students participated in the competition.",
    definition: "To take part in an activity or event."
  },
  {
    word: "reliable",
    image: "https://plus.unsplash.com/premium_photo-1661906789703-a25a1e53180e?q=80&w=1170&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
    synonyms: ["trustworthy", "dependable", "responsible"],
    example: "He’s a reliable worker who always finishes tasks on time.",
    definition: "Able to be trusted or depended on."
  },
  {
    word: "significant",
    image: "https://media4.giphy.com/media/v1.Y2lkPTc5MGI3NjExaWE1ODN3cjA4cmVmMHZ3NXF3YTN1ZWQ0aDJiYTE4bm5qMGxlY3V2NiZlcD12MV9pbnRlcm5hbF9naWZfYnlfaWQmY3Q9Zw/RxRYRJB8lY9KBbBNP0/giphy.gif",
    synonyms: ["important", "notable", "meaningful"],
    example: "The discovery was a significant breakthrough.",
    definition: "Large or important enough to be noticed or to have an effect."
  }
];
